import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import s from './Content.scss';
import classNames from 'classnames';

export const Default = () => {
  const { t } = useTranslation();
  return (
    <Text className={classNames(s.withDash, s.semiBold)}>
      {t('studio_package_picker.header.strip.money_back')}
    </Text>
  );
};
